import React, { MouseEvent } from "react";
import styled from "styled-components";

import { useFollowToggle } from "../../../hooks/useFollowToggle";

const FollowIconButton = styled.button<{ $isFollowing: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: #fcfcfc;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;

  .material-symbols-rounded {
    font-size: 24px;
    color: ${(props) =>
      props.$isFollowing ? "var(--soremo-blue)" : "#f0f0f0"};
    font-variation-settings: ${(props) =>
      props.$isFollowing ? "'FILL' 1" : "'FILL' 0"};
    transition: all 0.2s ease;

    &:hover {
      color: var(--soremo-blue);
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

interface MemberFollowButtonProps {
  userId: number | undefined;
  /** 行データから取れる初期フォロー状態（無ければ false） */
  initialIsFollowing?: boolean;
}

/**
 * プロジェクトメンバー一覧の Bookmark（フォロー）アイコンボタン。
 * クリックでフォロー / アンフォローをトグルする。ドラッグ操作と
 * 干渉しないよう pointer / mouse / click をすべて stopPropagation する。
 */
const MemberFollowButton: React.FC<MemberFollowButtonProps> = ({
  userId,
  initialIsFollowing = false,
}) => {
  const { isFollowing, toggle, isLoading } = useFollowToggle(
    userId,
    initialIsFollowing,
  );

  const stop = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
  };

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    void toggle();
  };

  return (
    <FollowIconButton
      type="button"
      $isFollowing={isFollowing}
      onClick={handleClick}
      onPointerDown={stop}
      onMouseDown={stop}
      disabled={!userId || isLoading}
      aria-label={isFollowing ? "フォローを解除" : "フォローする"}
    >
      <span className="material-symbols-rounded">bookmark</span>
    </FollowIconButton>
  );
};

export default MemberFollowButton;
